import { UI } from '/common/types'
import { i18nStore } from '../../../store'

export function toInlineList(opts: UI.UISettings['msgOptsInline']) {
  const i18n = i18nStore.getState()

  const msgInlineLabels: Record<UI.MessageOption, string> = {
    edit: i18n.t.settings_ui_msg_edit,
    regen: i18n.t.settings_ui_msg_regenerate,
    prompt: i18n.t.settings_ui_msg_promptView,
    fork: i18n.t.settings_ui_msg_fork,
    trash: i18n.t.settings_ui_msg_delete,
    attach: i18n.t.settings_ui_msg_attach,
    visible: i18n.t.settings_ui_msg_visibility,
    'gen-image': i18n.t.settings_ui_msg_genImage,
    'gen-json': i18n.t.settings_ui_msg_genJson,
  }

  const next = Object.entries(opts).map(([key, item], i) => ({
    id: i,
    value: key,
    label: msgInlineLabels[key as UI.MessageOption],
    enabled: item.outer,
  }))

  return next
}
